import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { useUsecaseErrorHandler } from '../../hooks/use-usecase-error-handler.hook';
import styled from '@xstyled/styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var ErrorContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100vh;\n  min-height: 100vh;\n"])));
export var UsecaseErrorHandler = function UsecaseErrorHandler(_ref) {
  var error = _ref.error,
      onBackToHome = _ref.onBackToHome,
      errorMessages = _ref.errorMessages,
      children = _ref.children;

  var _useUsecaseErrorHandl = useUsecaseErrorHandler({
    error: error,
    onBackToHome: onBackToHome,
    errorMessages: errorMessages
  }),
      errorComponent = _useUsecaseErrorHandl.errorComponent,
      hasError = _useUsecaseErrorHandl.hasError;

  return hasError ? /*#__PURE__*/_jsx(ErrorContainer, {
    children: errorComponent
  }) : /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};